const doc = [({"en":({"js":({"nemoa":({"activities":({"nav":({"index":({"activities":"Activities", "offers":"Offers", "mine":"Mine"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;